import React, { useMemo } from 'react';
import { Container } from 'react-bootstrap';
import HomeCarousel from '../components/HomeCarousel';
import { HomeContainer } from '../components/styles/HomeStyles';
import {
  RANDOM_ARTICLE_TITLE,
  ATTRACTIONS_RECOMMENDATIONS_TITLE,
} from '../components/Home/consts';
import { RecommendationsContainer } from '../components/Attraction/Attraction.styles';
import ArticleCardsContainer from '../components/Article/ArticleCardContainer';
import AttractionsList from '../components/Attraction/AttractionsList';
import { attractions } from '../components/Home/Data/Attractions';
import { articlesCardData } from '../content/articles/ArticlesCardData';
import CountryCarousel from '../components/International/CountryCarousel';

const getRandomArticles = (
  articles: typeof articlesCardData,
  count: number
) => {
  const allArticles = Object.entries(articles).flatMap(
    ([country, countryArticles]) =>
      countryArticles.map((article) => ({
        ...article,
        countrySlug: country,
      }))
  );

  const shuffled = [...allArticles].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const Home = () => {
  const randomArticles = useMemo(
    () => getRandomArticles(articlesCardData, 6),
    []
  );

  return (
    <HomeContainer>
      <HomeCarousel />
      <CountryCarousel />
      <RecommendationsContainer>
        <Container>
          <ArticleCardsContainer
            title={RANDOM_ARTICLE_TITLE}
            articles={randomArticles}
          />
          {/* <AttractionsList
            title={ATTRACTIONS_RECOMMENDATIONS_TITLE}
            attractions={attractions}
          /> */}
        </Container>
      </RecommendationsContainer>
    </HomeContainer>
  );
};

export default Home;
